module.exports = __webpack_public_path__ + "img/rencai.8c86c050.png";